import { ImageProps } from "next/image";

export default function imageLoader({ src, width, quality, height }: ImageLoaderProps) {
  return `${process.env.NEXT_PUBLIC_BASE_URL}/cdn-cgi/image/dpr=${quality || 2},${width ? `,width=${width}` : ""},${
    height ? `,height=${height}` : ""
  }${src}`;
}

type ImageLoaderProps = Pick<ImageProps, "src" | "width" | "quality" | "height">;
